import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M6 10.23a1 1 0 00.863-.496A1 1 0 007 9.23V8a.25.25 0 01.25-.25h10.11a1.5 1.5 0 000-3H7.25A.25.25 0 017 4.48V3.23a1 1 0 00-1.51-.86l-5 3a1 1 0 000 1.72l5 3a1 1 0 00.51.14zM23.51 16.91l-5-3a1 1 0 00-1.51.86V16a.25.25 0 01-.25.25H6.64a1.5 1.5 0 100 3h10.11a.25.25 0 01.25.25v1.25a1 1 0 001.51.86l5-3a1 1 0 000-1.72v.02z",
      fill: "#2D6DED"
    }
  )
);
export {
  t as default
};
